<template>
    <div class="relative h-full w-full overflow-hidden" ref="wrapper">
        <div ref="content" class="h-full overflow-y-scroll pr-2" @scroll="updateBar">
            <slot />
        </div>

        <!-- Fake scrollbar -->
        <div v-if="hasOverflow" class="absolute right-0 top-0 h-full w-2 bg-green-200"></div>
        <div
            v-if="hasOverflow"
            ref="bar"
            class="absolute right-0 top-0 h-full w-2"
            :style="{ height: barHeight + 'px', transform: `translateY(${barTop}px)` }">
            <div class="h-full w-full bg-green-600"></div>
        </div>
    </div>
</template>

<script setup>
    const wrapper = ref(null);
    const content = ref(null);
    const bar = ref(null);

    const barHeight = ref(0);
    const barTop = ref(0);
    const hasOverflow = ref(false);

    const updateBar = () => {
        const el = content.value;
        const visible = el.clientHeight;
        const total = el.scrollHeight;

        hasOverflow.value = total > visible + 1;

        const ratio = visible / total;
        barHeight.value = Math.max(20, visible * ratio);

        const progress = el.scrollTop / (total - visible);
        barTop.value = (wrapper.value.clientHeight - barHeight.value) * progress;
    };

    onMounted(() => {
        updateBar();
    });

    const refresh = () => {
        updateBar();
    };

    defineExpose({ refresh });
</script>

<style scoped>
    /* Prevent iOS momentum scrolling from breaking layout */
    ::-webkit-scrollbar {
        display: none;
    }
</style>
